import {
  CMHeadingContainer,
  CMOffer,
  CMBox,
  CMImage,
  CMImageBox,
} from "./payment-method.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos";
import Image from "../../image/image.component";

const PaymentMethod = ({
  handleNext,
  handlePrev,
  title,
  subtitle,
  bankTransfer,
  visaCard,
  masterCard,
  bankTransferSubtitle,
}) => {
  return (
    <>
      <CMBox>
        <CMHeadingContainer>
          <h3>{title}</h3>
          <h5>{subtitle}</h5>
        </CMHeadingContainer>

        <CMImageBox className="dotted-border">
          <CMImage>
            <Image src={masterCard} />
          </CMImage>
          <CMImage onClick={handleNext}>
            <Image src={visaCard} />
          </CMImage>
        </CMImageBox>

        <CMHeadingContainer>
          <h3>{bankTransfer}</h3>
          <h5>{bankTransferSubtitle}</h5>
        </CMHeadingContainer>

        <CMOffer>
          <Button buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}>
            Bank Details
            <span>
              <ArrowForwardIcon />
            </span>
          </Button>
        </CMOffer>
      </CMBox>
    </>
  );
};
export default PaymentMethod;
